import { StateService } from "@uirouter/angularjs";
import angular, { Injectable } from "angular";
import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
} from "../../forms/formView";
import { ColumnDefinitionService } from "../../grids/columns/columnDefinitionService";
import {
  GridConfiguration,
  RecordGridViewService,
} from "../../views/recordGridView";
//import { LookupManagementServiceProviderConfig } from "./config";

export interface LookupManagementConfigFactory {
  (...args: any[]): LookupManagementConfig;
}

export interface LookupManagementConfig {
  name?: string;
  fetchFormModel: (id: any) => any;
  displayName?: string;
  baseUrl: string;
  getLongItemDisplay?: (item: any) => string;
}

export interface LookupEntry {
  displayName: string;
  config: Injectable<LookupManagementConfigFactory>;
}

export interface TypeDisplayInfo {
  name: string;
  displayName: string;
}

export interface TypeSimilarItemInfo {
  name: string;
  id: string;
}

export interface LookupEntryCollection {
  [name: string]: LookupEntry;
}

export interface LookupManagementServiceProviderConfig {
  lookupManagementServiceProviderName: string;
  lookupManagementServiceName: string;
  baseStateSref: string;
  entryView?: string;
  defaultModifyPermission: string;
}

export class LookupManagementService {
  constructor(
    private readonly lookupManagementConfigs: LookupEntryCollection,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly $injector: angular.auto.IInjectorService,
    public config: LookupManagementServiceProviderConfig
  ) {}

  getConfigs(): TypeDisplayInfo[] {
    return Object.entries(this.lookupManagementConfigs).map((entry) => {
      return {
        name: entry[0],
        displayName: entry[1].displayName,
      };
    });
  }

  getLookupConfig(name: string) {
    const entry = this.lookupManagementConfigs[name];
    const config = this.$injector.invoke(entry.config);
    config.name = name;
    config.displayName ??= entry.displayName;
    return config;
  }

  getFormConfiguration(name: string): FormViewConfig | undefined {
    const config = this.formViewService.getFormViewConfig(name);

    if (config === undefined) return undefined;

    const defaultSubmit = config.submitForm!;
    config.submitForm = (args: FormSubmitArgs) =>
      defaultSubmit(args).then((result) => {
        this.$state.go("^.grid");
        return result;
      });

    return config;
  }

  getGridConfig(name: string): GridConfiguration | undefined {
    const gridConfiguration =
      this.recordGridViewService.getGridConfiguration(name);

    if (gridConfiguration === undefined) {
      return undefined;
    }

    gridConfiguration?.columns?.splice(
      0,
      0,
      this.columnDefinitionService.getLinkColDef({
        colId: "edit",
        headerName: "edit",
        iconClass: "text-primary fa fa-pencil",
        width: 20,
        requiresPermission: gridConfiguration.showAddButtonPermission,
        stateExpression: "^.edit({ id: data.Id })",
      })
    );
    gridConfiguration?.columns?.splice(
      0,
      0,
      this.columnDefinitionService.getLinkColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        width: 20,
        colId: "info",
        stateExpression: "^.info({ id: data.Id })",
      })
    );

    return gridConfiguration;
  }
}
